export default __webpack_public_path__ + "static/media/deleteicon.02607736.svg";